import { subscribeToRouter, currentUser, onUserChange } from './common'

let isEnabled = false

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.src = url

    const head = document.head || document.getElementsByTagName('head')[0]
    head.appendChild(script)

    script.onload = resolve
    script.onerror = reject
  })
}

const CUSTOM_DIMENSIONS = {
  VISIT_MEDIUM_ID: null,
  ACTION_MEDIUM_ID: null
}

export function trackEvent(category, action, name = null, value = null, medium = null) {
  if (!isEnabled) {
    return
  }
  const params = ['trackEvent', category, action]
  params.push(name !== null ? name : '')
  params.push(value !== null ? value : '')
  if (medium !== null && CUSTOM_DIMENSIONS.ACTION_MEDIUM_ID !== null) {
    params.push({ ['dimension' + CUSTOM_DIMENSIONS.ACTION_MEDIUM_ID]: medium })
  }
  window._paq && window._paq.push(params)
}

export function enable(
  siteId,
  cookieDomain,
  visitMediumDimensionId = null,
  actionMediumDimensionId = null
) {
  const host = 'https://ana.thenorth.io'
  const trackerSrc = `${host}/js/`
  const trackerUrl = `${host}/js/`

  if (visitMediumDimensionId) {
    CUSTOM_DIMENSIONS.VISIT_MEDIUM_ID = parseInt(visitMediumDimensionId)
  }
  if (actionMediumDimensionId) {
    CUSTOM_DIMENSIONS.ACTION_MEDIUM_ID = parseInt(actionMediumDimensionId)
  }

  const _paq = window._paq || []
  window._paq = _paq
  _paq.push(['setTrackerUrl', trackerUrl])
  _paq.push(['setSiteId', siteId])
  _paq.push(['setCookieDomain', cookieDomain])
  _paq.push(['enableLinkTracking'])

  const searchParams = new URL(document.location).searchParams
  const medium = searchParams.get('mtm_medium')
  if (medium && CUSTOM_DIMENSIONS.VISIT_MEDIUM_ID) {
    _paq.push(['setCustomDimension', CUSTOM_DIMENSIONS.VISIT_MEDIUM_ID, medium])
  }

  const user = currentUser()
  if (user) {
    _paq.push(['setUserId', user.id])
    _paq.push(['trackPageView'])
  }

  loadScript(trackerSrc).catch(e => {
    console.log('Could not load load tracker script', e)
  })

  onUserChange(({ user }) => {
    const _paq = window._paq
    if (user) {
      _paq.push(['setUserId', user.id])
      _paq.push(['trackPageView'])
    } else {
      _paq.push(['resetUserId'])
      _paq.push(['appendToTrackingUrl', 'new_visit=1'])
      _paq.push(['trackPageView'])
      _paq.push(['appendToTrackingUrl', ''])
    }
  })

  subscribeToRouter(url => {
    window._paq.push(['setCustomUrl', url])
    window._paq.push(['trackPageView'])
  })

  isEnabled = true
}
